<div class="page-outer-wrapper">
  <div class="page-header">
    <div class="hamburger">
      <a routerLink="/overwatch"><img src="/assets/images/apple-touch-icon-72x72-precomposed.png" height="28" width="28"></a>
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>
  <div class="page-content-background">
    <div class="page-content" style="padding: 12px; max-width: 650px; height: calc(100vh - 42px); overflow: scroll;">

      <h2>Help / Support</h2>

      <h3>Overview (home page)</h3>

      <p>
        The railview application has two main methods of viewing the rail network; the overview page and
        the panorama page.When you login you will immediately see the overview page.  This shows you the
        entire rail network, or as much as you have been granted access to, by way of your customer group
        and the projects you are a member of.
      </p>

      <p>
        From the overview page you will see a number of colored lines and circles with numbers inside them.
        The lines are the subdivisions of the rail network.  You can <b>CLICK</b> anywhere on one of the lines
        to jump to the panorama nearest where you clicked.  You can also hover over a line to see its
        subdivision label.
      </p>

      <p>
        The circles with numbers in them are clusters of the panoramas. The number is the count of
        panoramas in that particular cluster.  If you zoom in (just use the mouse wheel), you will see
        that the clusters "spider" into smaller clusters. You can also <b>CLICK</b> a cluster to zoom it in
        to the next level. if you zoom in far enough, you will see the actual map markers for each panorama.
      </p>

      <p>
        There is no need to zoom all the way in though; if you just want to jump to something reasonable,
        simply <b>RIGHT CLICK</b> on a cluster, and you will be taken to the panorama that is nearest the
        geographic center of that cluster.
      </p>

      <p>
        If you don't see clusters on a given subdivision line, it means either there are no clusters
        for that subdivision, or you have not been granted access to that subdivision.  If you need
        additional access, please contact your manager.
      </p>

      <p>
        On the right side you'll see a multi-select drop down.  This is the mile post selector.  You
        can at any time select a subdivision, timeline and a mile post, and then press <b>RETURN</b> or
        <b>CLICK GO</b> to jump directly to any mile post position.
      </p>

      <p>
        Timelines are just a month and day when panoramas were captured.  When you view the rail network
        as a whole, you are seeing the panoramas for the most recent timeline(s) in each subdivision.   You
        can use the mile post selector to override this and jump directly a any panorama in any specific timeline.
      </p>

      <p>
        The overview page is also a Google style map, the usual pan/zoom abilities are all available.
      </p>

      <h3>Panorama Viewer</h3>

      <p>
        When you navigate from the overview page to a specific panorama, you will be given a screen
        that is a 360&deg; panorama viewer with various controls.  This viewer allows you to both
        view the panorama in full detail, but also manipulate it (brightness/contrast filtering) and
        also navigate to other nearby panoramas, or use the mile post selector (as on the overview page),
        to jump to any panorama you wish to.
      </p>

      <p>
        The controls available on the panorama page:
      </p>

      <ul>
        <li>Bottom left - <b>CONTROL BAR</b> - Here you have all the of the quick actions. Just hover your
        mouse over each action button for brief help.</li>
        <li>Bottom above control bar - <b>MINI MAP</b> - This is like the overview page, but its focused on
        the panorama you are viewing.  You can still pan and zoom as usual, and if you click other
        markers you can jump directly to them.  You will also see a blue "viewing cone" which shows
        your viewing angle relative to the geography.  As with the overview page, you can also click
        on the subdivision lines to jump to the panorama nearest to where you clicked.  if you hover
        over any marker, you will also get some brief details about that panorama.</li>
        <li>Bottom center - <b>NAVIGATION</b> - Click on the next (UP) arrow to jump to the next panorama
        in the direction of travel.  Similarly use the previous (DOWN) arrow to jump backwards.  The
        left and right arrows will also be shown if there are tracks on either side where you could
        jump to.  The center button (gold arrow) takes you back to the overview page.</li>
        <li>Bottom right - <b>FILTERING</b> - Use the brightness and contrast knobs to touch up the
        filtering for the image.  Just click and drag the outer circle to adjust either.  To reset
        one of them, just click the icon in the center of the knob. To reset the filters and the view,
        use the reset action in the control bar.</li>
        <li>Top right - <b>MILE POST SELECTION</b> - As on the overview page you can use this
        multi-select dropdown to jump directly to any mile post any timeline of any subdivision. You can
        jump immediately to entering a mile post at anytime by <b>PRESSING P</b> on the keyboard, punch in
        your number and press <b>RETURN</b> (or <b>CLICK GO</b>) to go.</li>
      </ul>


      <h3>Keyboard & Mouse</h3>

      <table cellpadding="0" cellspacing="0" style="width: 100%;">

        <!-- Using the Map -->
        <tr>
          <td colspan="2">MAP / MINIMAP</td>
        </tr>
        <tr>
          <th>Control</th><th>Action</th>
        </tr>
        <tr>
          <td>LEFT</td><td>Pan west</td>
        </tr>
        <tr>
          <td>RIGHT</td><td>Pan east</td>
        </tr>
        <tr>
          <td>UP</td><td>Pan north</td>
        </tr>
        <tr>
          <td>DOWN</td><td>Pan south</td>
        </tr>
        <tr>
          <td>MOUSE WHEEL (UP)</td><td>Zoom in</td>
        </tr>
        <tr>
          <td>MOUSE WHEEL (DOWN)</td><td>Zoom out</td>
        </tr>
        <tr>
          <td>CLICK (DRAG)</td><td>Pan</td>
        </tr>
        <tr>
          <td>&nbsp;</td><td>&nbsp;</td>
        </tr>

        <!-- overview page controls -->

        <tr>
          <td colspan="2">OVERVIEW PAGE</td>
        </tr>
        <tr>
          <th>Control</th><th>Action</th>
        </tr>
        <tr>
          <th>&nbsp;</th><th>&nbsp;</th>
        </tr>

        <!-- panorama page controls -->

        <tr>
          <td colspan="2">PANORAMA PAGE</td>
        </tr>
        <tr>
          <th>Control</th><th>Action</th>
        </tr>
        <tr>
          <td>LEFT</td><td>Look more to the left</td>
        </tr>
        <tr>
          <td>RIGHT</td><td>Look more to the right</td>
        </tr>
        <tr>
          <td>UP</td><td>look more up</td>
        </tr>
        <tr>
          <td>DOWN</td><td>Look more down</td>
        </tr>
        <tr>
          <td>MOUSE WHEEL (UP)</td><td>Zoom in</td>
        </tr>
        <tr>
          <td>MOUSE WHEEL (DOWN)</td><td>Zoom out</td>
        </tr>
        <tr>
          <td>CLICK (DRAG)</td><td>Pan the viewing angle (3D)</td>
        </tr>
        <tr>
          <td>W</td><td>Jump to panorama in front of this one</td>
        </tr>
        <tr>
          <td>S</td><td>Jump to panorama behind this one</td>
        </tr>
        <tr>
          <td>A</td><td>Jump to track on left (if possible)</td>
        </tr>
        <tr>
          <td>D</td><td>Jump to track on right (if possible)</td>
        </tr>
        <tr>
          <td>R</td><td>Reset the panorama view (back to center, no image filter)</td>
        </tr>
        <tr>
          <td>M</td><td>Toggle the minimap</td>
        </tr>
        <tr>
          <td>F</td><td>Toggle the mile post selector</td>
        </tr>
        <tr>
          <td>C</td><td>Toggle the control bar</td>
        </tr>
        <tr>
          <td>O</td><td>Return to overview page</td>
        </tr>
        <tr>
          <td>P</td><td>Move keyboard focus to the mile post input.</td>
        </tr>
        <tr>
          <td>F11</td><td>Toggle fullscreen mode</td>
        </tr>
        <tr>
          <td>&nbsp;</td><td>&nbsp;</td>
        </tr>

      </table>


      <h2>General Support</h2>

      <p>
        For general help & support please contact your manager.
      </p>


    </div>
    <div id="pano-footer" class="pano-footer"></div>
  </div>
</div>
